module.exports = __webpack_public_path__ + "static/media/display-1.4542775d.png";